import React from 'react'
import '../DropMenu.scss'

export default function DropMenu() {
  return (
    
          <div className="drop-menu-wrap">

             <div className="blue-box-drop"><div className="bottom-triangle"></div></div>

                <p className="about-drop drop-words">About</p>

                <p className="services-drop drop-words">Services</p>

                <p className="projects-drop drop-words">Projects</p>

               <button className="drop-menu-button">CONTACT</button>

          </div>

    
  )
}
